import registerBoard from '../../../common/boards/index';
import presentationalComponent from './Board';
import containerComponent from './BoardContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerBoard({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.COLOR, TOOLS.ICON],
        tooltip: isApple ? '⌃⌘B' : 'Ctrl+Alt+B',
    });
